import "../styles/faq.scss";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState } from "react";

export default function FAQ(props) {
  const [selectTab, setSelectTab] = useState("");

  const handleFaq = (tab) => {
    if (tab === selectTab) {
      setSelectTab("");
    } else {
      setSelectTab(tab);
    }
  };

  return (
    <section className="FAQ__main">
      <h2>Frequently Asked Questions</h2>
      <hr />
      <section className="faqs">
        <h3 onClick={() => handleFaq("1")}>
          What is the dress code?{" "}
          {selectTab === "1" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "1" ? <p>Smart casual.</p> : null}
        <hr />
        <h3 onClick={() => handleFaq("2")}>
          What do I need to bring?{" "}
          {selectTab === "2" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "2" ? (
          <p>
            Please bring your ticket (either on your mobile device or printed
            out). Please also bring a notepad and a pen to take notes throughout
            the event.
          </p>
        ) : null}
        <hr />
        {/* <h3 onClick={() => handleFaq("3")}>
          Will I have to buy anything?{" "}
          {selectTab === "3" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "3" ? (
          <p>
            No. There is no obligation to buy anything. This course is value
            packed and has been designed to give you the tools and resources to
            get started in Property. We do offer and will introduce additional
            mentorship to allow you to fast-track the journey.
          </p>
        ) : null}

        <hr /> */}
        <h3 onClick={() => handleFaq("4")}>
          Refreshments?{" "}
          {selectTab === "4" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "4" ? (
          <p>
            Teas/coffees will be provided during comfort breaks.
            <br />
            Lunches will be provided, please contact the office if you require a
            vegetarian option.
          </p>
        ) : null}
        <hr />
        <h3 onClick={() => handleFaq("5")}>
          Time of event?{" "}
          {selectTab === "5" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "5" ? (
          <p>
            Doors open for registration at 9.30am <br />
            Event timings - 10:00am-4:30pm
          </p>
        ) : null}
        <hr />
        <h3 onClick={() => handleFaq("6")}>
          Where does the event take place?{" "}
          {selectTab === "6" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "6" ? (
          <p>
            The event will take place at PMW HQ, Cambuslang, Glasgow. There is
            limited parking onsite and the nearest train stations are Cambuslang
            and Carmyle (check your ticket confirmation email for full details).
          </p>
        ) : null}
        {/* <hr />
        <h3 onClick={() => handleFaq("7")}>
          Do I get updates to the course content?{" "}
          {selectTab === "7" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "7" ? (
          <p>
            Yes, you will automatically receive any updates or new content added
            to the course during your access period.
          </p>
        ) : null}
        <hr />
        <h3 onClick={() => handleFaq("8")}>
          Is there a community or support group?{" "}
          {selectTab === "8" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "8" ? (
          <p>
            The ‘community’ section of the online portal is where you can
            interact with other property sourcers, find/sell your deals, and
            joint venture with others. You can even submit your deal to PMW’s
            own database of investors, if you’ve not already lined up your own
            investors, or you find a deal that doesn’t suit your own investors.
          </p>
        ) : null}
        <hr />
        <h3 onClick={() => handleFaq("9")}>
          What if I need help or have questions?{" "}
          {selectTab === "9" ? (
            <KeyboardArrowDownIcon className="faq--icon" />
          ) : (
            <KeyboardArrowRightIcon className="faq--icon" />
          )}
        </h3>
        {selectTab === "9" ? (
          <>
            <p>
              For any issues with your account or programme access, you can use
              the “PMW Helpdesk” link inside the online portal. Or you can reach
              out to Team PMW on the following channels:
            </p>
            <ul>
              <li>
                Phone: <a href="tel:08002335596">0800 233 5596</a>
              </li>
              <li>
                Email: <a href='mailto:main"teampmw.com'>mail@teampmw.com</a>
              </li>
              <li>WhatsApp/Text: 07893 945233</li>
            </ul>
          </>
        ) : null}
        <hr /> */}
      </section>
    </section>
  );
}
